export const roles = ['owner', 'admin', 'tech', 'bill'];
export const fieldsMapping = {
  given: 'firstname',
  family: 'lastname'
};
export const legacyContactTypes = [{
  value: 0,
  label: 'individual'
}, {
  value: 1,
  label: 'company'
}, {
  value: 2,
  label: 'association'
}, {
  value: 3,
  label: 'publicbody'
}];
export const contactTypeReseller = {
  value: 4,
  label: 'company'
};
export const contactTypes = [{
  value: 'individual',
  label: 'individual'
}, {
  value: 'company',
  label: 'company'
}, {
  value: 'association',
  label: 'association'
}, {
  value: 'publicbody',
  label: 'publicbody'
}];
export const getNumberContactTypeFromString = organizationType => legacyContactTypes.find(type => type.label === organizationType)?.value || 0;
export const maybeConvertType = anyType => [...legacyContactTypes, contactTypeReseller].find(type => type.value === Number(anyType) || type.label === anyType)?.label || 'individual';
export const maybeConvertContactType = contact => ({
  ...contact,
  type: maybeConvertType(contact.type)
});